import type { WatermarkThumbShape } from 'fym-shared/src/music24/watermarkUpsell';

/** The four uses of a file that open the choice (design: trial-upsell a2). */
export type WatermarkChoiceSurface = 'download' | 'share' | 'post' | 'zip';

export interface WatermarkChoiceRequest {
  surface: WatermarkChoiceSurface;
  /** The name of the file ("Story (Out now)"); null for the kit zip. */
  label: string | null;
  songTitle: string | null;
  /** An absolute picture address of the file. */
  thumbUrl: string | null;
  shape: WatermarkThumbShape;
  /** The size of the file as it is now. */
  width: number | null;
  height: number | null;
  /** True for a preview render: the clean file is two times the size. */
  preview: boolean;
  /** The kit zip: the files in it. */
  fileCount?: number;
  /**
   * A download: the address of the same-origin file. The second row is then a real
   * `<a href download>`, so one click starts the same download as before.
   */
  downloadHref?: string;
  /** Called when the second row starts the download, for the analytics of the place. */
  onDownload?: () => void;
  /** Any other use: what the second row does (make the share link, open the Composer, build the zip). */
  onContinue?: () => void;
}

/**
 * The open choice, held in the tab (the pattern of `addAssetDialogStore`). A download link, a
 * share button or "Post it" anywhere in the app opens it; `WatermarkChoiceHost` draws it one time.
 */
let current: WatermarkChoiceRequest | null = null;
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach((listener) => listener());
}

export function openWatermarkChoice(request: WatermarkChoiceRequest): void {
  current = request;
  emit();
}

export function closeWatermarkChoice(): void {
  if (current === null) {
    return;
  }
  current = null;
  emit();
}

export function getWatermarkChoice(): WatermarkChoiceRequest | null {
  return current;
}

export function subscribeWatermarkChoice(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
